import React, { useEffect, useState } from "react";
import { InputText } from "primereact/inputtext";
import { SelectButton } from "primereact/selectbutton";
import { CronExpressonBuilder } from "./CronExpressonBuilder";
import * as _ from "lodash";
import { DataTable, Column } from "primereact/datatable";
import * as moment from 'moment';
import { Button } from "primereact/button";
import { v4 } from "uuid";
import { Fieldset } from "primereact/fieldset";
import { ReportService } from "../../service/ReportService";

export default function CronConfig(props) {

  const schedules = props.report?.config?.dataset_refresh_cron_expression ?? [];

  const [lastRefresh, setLastRefresh] = useState("checking...");
  const loadInfo = async () => {
    if(props.report){
      setLastRefresh("checking...")
      try {
        const service = new ReportService();
        const _lastRefresh = await service.getLastDatasetRefresh({ id: props.report.client_id }, props.report )
        setLastRefresh(_lastRefresh);
      } catch (error) {
        setLastRefresh(error.toString());
      }
    }
  }

  const refresh = async () => {
    console.log("Requesting refresh")
    setLastRefresh("Requesting...")
    try {
      const service = new ReportService();
      await service.requestDatasetRefresh({ id: props.report.client_id }, props.report )
      await loadInfo();
    } catch (error) {
      setLastRefresh(error.toString());
    }
  }

  useEffect(() => {    
    loadInfo()

  }, [props.report?.powerbi_dataset_id]);

  const [unSavedChanges, setUnSavedChanges] = useState(false);

  const calculateNext = (exp) => {
    try {
      const CronX = require('cron-converter');
      const cronInstance = new CronX({ timezone: "America/Sao_Paulo" });
      cronInstance.fromString(exp);
      var schedule = cronInstance.schedule();
      return schedule.next().toISOString();  
    } catch (error) {
      return ""
    }
  }

  const calculateNextDatasetRefresh = (schedules) => {
    let next = "";
    schedules.forEach(schedule => {
      schedule.next = calculateNext(schedule.value)
      if(((schedule.next ?? "") !== "") && (next === "" || schedule.next < next))
      {
        next = schedule.next;
      }
    });

    return next;
  }

  const updateReport = (_schedules) => {
    let report = { ...props.report };
    _.set(report, "config.next_dataset_refresh", calculateNextDatasetRefresh(_schedules));
    _.set(report, "config.dataset_refresh_cron_expression", _schedules);
    props.onReportUpdated(report);
    setUnSavedChanges(true);
  }
  const add = () => {
    const _schedules = schedules.concat({ id: v4(), value: "", next: "", custom: false})
    updateReport(_schedules);
  }

  const remove = (schedule) => {
    const _schedules = schedules.filter(s => s.id !== schedule.id)
    updateReport(_schedules);
  }

  const update = (schedule) => {
    schedule.next = calculateNext(schedule.value);
    const _schedules = schedules.map(s => s.id === schedule.id ? schedule : s)
    updateReport(_schedules);
  }

  const parseRefresh = (refresh) => {

    const getDetailedStatus = (refresh) => {
      // console.log("getDetailedStatus", refresh?.status, refresh?.serviceExceptionJson, refresh?.serviceExceptionJson?.errorCode);
      if(refresh?.status === "Failed" && refresh?.serviceExceptionJson){
        try {
          return `${refresh?.status}: ${JSON.parse(refresh?.serviceExceptionJson).errorCode}`  
        } catch (error) {
          return refresh?.status;
        }
      }
      return refresh?.status;
    }

    if(refresh){
      const parsedValue = 
        refresh === "Requesting..." ? refresh 
        : (refresh?.endTime ?? "") === "" ? 
          (refresh?.id ?? "") === "" ? "checking..." 
          : "In Progress" 
        : moment(refresh?.endTime).format("DD/MM/YYYY HH:mm") + " (" + getDetailedStatus(refresh) + ")";    
      if((refresh?.endTime ?? "") === "" && refresh !== "checking..." && refresh !== "Error: Request failed with status code 403"){
        console.log("refresh.endTime is empty. will try again in 5 secoonds")
        setTimeout(loadInfo, 10000)
      }
    
      return parsedValue;
    }
    return '-';
  }

  return (
    <div className="p-field p-col-12">
      <Fieldset legend={`Dataset Refresh Schedules${ unSavedChanges ? " (*unsaved changes)" : ""}`}>
      Last Refresh: { parseRefresh(lastRefresh) } <br/>
      Next Refresh: { (props.report?.config?.next_dataset_refresh ?? "") === "" ? "-" : moment(props.report?.config?.next_dataset_refresh).format("DD/MM/YYYY HH:mm")}
      <br/>
      <DataTable value={schedules} autoLayout={true}>
          <Column field="custom" header="Type" body={(schedule) => 
            <SelectButton
              value={ schedule.custom ?? false }
              onChange={(e) => update({...schedule, custom: e.value})}
              options={[{ value: true, label: "Custom" }, { value: false, label: "Normal" }]}
              optionLabel="label"
              optionValue="value"
              style={{ width: "200px" }}
            />}>
          </Column>
          <Column field="value" header="Cron Expression" body={(schedule) => 
            schedule.custom ? 
              <InputText value={schedule.value ?? ""} onChange={(e) => update({...schedule, value: e.target.value})} />
              :
              <CronExpressonBuilder value={schedule.value} onChange={(e) => update({...schedule, value: e.expression, next: e.next})} />
            }>
          </Column>
          <Column header="Next Run" style={{ whiteSpace: 'no-wrap', width: "200px"}} body={(schedule) => (schedule.next ?? "") === "" ? "-" : moment(schedule.next).format("DD/MM/YYYY HH:mm")}></Column>
          <Column body={(schedule) => 
            <Button icon="pi pi-trash" className="p-button-rounded p-button-danger" onClick={() => remove(schedule)} />
          }></Column>
      </DataTable><br/>
      <Button label="Add Schedule" icon="pi pi-plus" style={{width: '200px'}} onClick={add} />&nbsp;&nbsp;&nbsp;&nbsp;
      <Button label="Refresh Now" icon="pi pi-refresh" style={{width: '200px'}} onClick={refresh} />
      </Fieldset>
      
    </div>
  );
}
